// APP ENTRY POINT

import "core-js/stable"; //Modules declared on webpack.common.js
import "regenerator-runtime/runtime";
// import "core-js/modules/es.promise";
// import "core-js/modules/es.array.iterator";

// "core-js/stable",
//     "regenerator-runtime/runtime",
//     "core-js/modules/es.promise",
//     "core-js/modules/es.array.iterator",


import Vue from "vue";
import VueRouter from "vue-router";
import VueFormGenerator from "vue-form-generator";

var VueScrollTo = require("vue-scrollto").default;



window.VueFormGenerator = VueFormGenerator; // needed for form validators
window.Vue = Vue;

import _ from 'lodash';
Vue.prototype._ = _ // TODO check if this is needed since bound to window


Vue.use(VueRouter,  VueScrollTo, VueFormGenerator)


// LEGACY
var jQuery = require("jquery");
window.$ = window.jQuery = window.jquery = jQuery;

var datetimepicker = require("eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js");
window.datetimepicker = datetimepicker;

require("bootstrap");

var appLegacy = require("Js/appLegacy");
window.appLegacy = appLegacy;


// CSS
require("bootstrap/dist/css/bootstrap.min.css");
require("./assets/css/main.css");

import store from "Js/store";
import router from "Js/routes.js";
import "Js/feathers";
import "Js/BF";
import './registerServiceWorker.js'

// GLOBAL COMPONENTS
import VRuntimeTemplate from "v-runtime-template";
Vue.component("html-renderer", VRuntimeTemplate);
Vue.component ("app" , require("@/assets/components/masters/app.vue").default)

// Trap duplicate router issue
const originalPush = router.push;
router.push = function(location, onResolve, onReject) {
  return originalPush.call(this, location, onResolve, onReject).catch(err => {
    if (err.name === 'NavigationDuplicated') {
    } else {
      throw err;
    }
  });
};

// VUE
var app = new Vue({
  store: store,
  el: "#app",
  router: router,
}).$mount("#app");

// Vue.config.errorHandler = function (err, vm, info) {
//     BF.errorThrow (10040, 'BF global errorHandler (See info for details)' , {err, info})
//     return false
// };
// Vue.config.warnHandler = function (err, vm, info) {
//     BF.errorThrow (10042, 'BF global warnHandler (See info for details)' , {err, info})
//     return false
// };

Vue.config.devtools = true; 
window.vueapp = app;

// Override the console.warn method
const originalConsoleWarn = console.warn;
console.warn = function(message, ...optionalParams) {
  if (!message.startsWith('cdn.tailwindcss.com should not be used in production.')) {
    originalConsoleWarn.apply(console, [message, ...optionalParams]);
  }
};